import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"

import {
    GridCell,
    Select,
    Theme,
    Icon,
    FieldLabel,
} from "@bdfx/mergado-ui-kit"

import { AvailableOptionsType } from "../types";
import { isGodModeOn } from "app/helpers/api";
import { isMultiSelectCloseOnChange, StyledSliderDiv } from "./filters";
import { ReduxList } from "app/types/app-types";
import { Slider } from "@mui/material";
import { FiltersFormType } from "products/types/filtertypes";
import { selectFormValues, updateInputValue } from "app/reducers/form";
import { StyledInputGroupFilter } from "shape-edit/forms/fields";

interface Props {
    filtersForm: FiltersFormType
    availableOptions: ReduxList<AvailableOptionsType>
    setIsDirty: Function
    updateInputValue: typeof updateInputValue
}

class ValidationsFilters extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    render() {
        const { availableOptions, filtersForm } = this.props

        const availableValidationsStatuses = [
            ...(isGodModeOn ? [{ value: 'ERROR', label: trans('status_ERROR') }] : []),
            { value: 'OK', label: trans('status_OK')},
            { value: 'NOT_OK', label: trans('status_NOT_OK')},
        ]

        const hasAlphaOptions = [
            { value: '1', label: trans('option_true')},
            { value: '0', label: trans('option_false')},
        ]

        const isFromNull = typeof filtersForm.image_validations?.correctness_percentage_offset?.from === "undefined" || filtersForm.image_validations?.correctness_percentage_offset?.from === null
        const isToNull = typeof filtersForm.image_validations?.correctness_percentage_offset?.to === "undefined" || filtersForm.image_validations?.correctness_percentage_offset?.to === null

        const filterFrom = isFromNull ? 50 : parseInt(`${filtersForm.image_validations?.correctness_percentage_offset?.from}`)
        const filterTo = isToNull ? 50 : parseInt(`${filtersForm.image_validations?.correctness_percentage_offset?.to}`)

        const availableObjectPositions = availableOptions.data && availableOptions.data.available_object_positions ?
            availableOptions.data.available_object_positions.map((o: string) => {
                const translated = trans(`${o}`)
                const d = "M13.3 13.4q0 1.6-1.2 2.8t-2.8 1.1-2.8-1.1-1.2-2.8 1.2-2.9 2.8-1.1 2.8 1.1 1.2 2.9zm21.3 7.9v9.3H5.3v-4L12 20l3.3 3.3 10.6-10.6zm1.9-14.6H3.3q-.2 0-.4.2t-.2.5v25.2q0 .3.2.5t.4.2h33.2q.3 0 .5-.2t.2-.5V7.4q0-.3-.2-.5t-.5-.2zm3.4.7v25.2q0 1.4-1 2.4t-2.4.9H3.3Q2 35.9 1 35t-1-2.4V7.4Q0 6 1 5t2.3-.9h33.2q1.4 0 2.4.9t1 2.4z"

                let transform = ''
                let style
                switch (o) {
                    case 'image_down':
                        transform = "scale(.5) translate(20, 40)"
                        break
                    case 'image_up':
                        transform = "scale(.5) translate(20, 0)"
                        break
                    case 'image_left':
                        transform = "scale(.5) translate(0, 20)"
                        break
                    case 'image_right':
                        transform = "scale(.5) translate(40, 20)"
                        break
                    case 'image_in_the_middle':
                        transform = "scale(.5) translate(20, 20)"
                        break
                    case 'vertical_image':
                        style = { transform: 'scaleX(0.25) translate(60px, 0px)' }
                        break
                    case 'horizontal_image':
                        style = { transform: 'scaleY(.25) translate(0px, 60px)' }
                        break
                    default:
                        transform = ''
                }
                return {
                    label: translated,
                    value: `${o}`,
                    text: <React.Fragment>
                        {o === 'complex_background' ? <Icon type="connectdevelop" color={Theme.orange} /> :
                            o === 'unknown_image_format' ? <Icon type={'question'} color={Theme.grey} /> :
                                o === 'ok' ? <Icon type={'check'} color={Theme.green} /> :
                                    <svg version="1.1" viewBox={`0 0 40 40`} width={20} height={20}>
                                        <linearGradient id={`gradient-${o}`} y1="0%" y2="100%">
                                            <stop offset="0%" stopColor="#eee" stopOpacity=".9" />
                                            <stop offset="100%" stopColor="#ccc" stopOpacity=".9" />
                                        </linearGradient>

                                        <rect width="40" height="40" x="0" y="0" fill={`url(#gradient-${o})`} />
                                        <path transform={transform} style={style} d={d} fill={'#fff'} />
                                    </svg>
                        }
                        {translated}
                    </React.Fragment>
                }
            }) : null

        return (
            <>
                {availableValidationsStatuses &&
                    <GridCell className={filtersForm.image_validations.status && Array.isArray(filtersForm.image_validations.status) && filtersForm.image_validations.status.length > 0 ? 'active-filter' : ''}>
                        <StyledInputGroupFilter
                            formName='filtersForm.image_validations.status'
                            singleChoice={false}
                            onChange={() => this.props.setIsDirty(true)}
                            transString={'filter_status'}
                            iconType={'all-sides-radix'}
                            showClear={filtersForm.image_validations.status && Array.isArray(filtersForm.image_validations.status) && filtersForm.image_validations.status.length > 0}
                            items={availableValidationsStatuses}
                            onClear={() => {
                                this.props.updateInputValue('filtersForm', 'image_validations.status', null)
                                this.props.setIsDirty(true)
                            }}
                        />
                    </GridCell>
                }

                {availableObjectPositions &&
                    <GridCell className={filtersForm.image_validations.object_position && Array.isArray(filtersForm.image_validations.object_position) && filtersForm.image_validations.object_position.length > 0 ? 'active-filter' : ''}>
                        <Select
                            name={`filtersForm.image_validations.object_position`}
                            multiple={true}
                            closeOnChange={isMultiSelectCloseOnChange}
                            options={availableObjectPositions}
                            label={<Icon type={'all-sides-radix'} text={trans('object_position')} />}
                            onChange={() => this.props.setIsDirty(true)}
                        />
                    </GridCell>
                }

                <GridCell className={filtersForm.image_validations.has_alpha ? 'active-filter' : ''}>
                    <StyledInputGroupFilter
                        formName='filtersForm.image_validations.has_alpha'
                        singleChoice={true}
                        onChange={() => this.props.setIsDirty(true)}
                        transString={'filter_has_alpha'}
                        iconType={'transparency-grid-radix'}
                        showClear={filtersForm.image_validations.has_alpha}
                        items={hasAlphaOptions}
                        onClear={() => {
                            this.props.updateInputValue('filtersForm', 'image_validations.has_alpha', null)
                            this.props.setIsDirty(true)
                        }}
                    />
                </GridCell>

                <GridCell className={!isFromNull || !isToNull ? 'active-filter' : ''}>
                    <StyledSliderDiv>
                        <FieldLabel><Icon type="margin-radix" text={trans('correctness_percentage_offset')} /></FieldLabel>
                        {(!isFromNull || !isToNull) &&
                            <span style={{ position: 'absolute', right: '10px' }} className='clickable' onClick={() => this.props.updateInputValue('filtersForm', 'image_validations.correctness_percentage_offset', null)}>
                                <Icon type={'close-light'} color={'#3a3a3a'} />
                            </span>
                        }

                        <Slider
                            value={filterFrom}
                            onChange={(event: Event, value: number[]) => {
                                this.props.updateInputValue('filtersForm', 'image_validations', {
                                    ...filtersForm.image_validations,
                                    correctness_percentage_offset: {
                                        from: value,
                                        to: filterTo,
                                    },
                                })
                            }}
                            color={isFromNull && isToNull ? 'secondary' : 'primary'}
                            track={"inverted"}
                            step={1}
                            min={0}
                            max={100}
                            marks={[{ value: 0, label: '0%' }, { value: 15 }, { value: 25, label: '25%' }, { value: 75 }, { value: 100, label: '100%' }]}
                            valueLabelDisplay="auto"
                            getAriaLabel={() => `${trans('correctness_percentage_offset')} [%]`}
                            getAriaValueText={(value) => `${value}%`}
                            valueLabelFormat={(value) => `${value}%`}
                        />
                    </StyledSliderDiv>
                </GridCell>

                <GridCell className={filtersForm.image_validations.mistake_set_by_user ? 'active-filter' : ''}>
                    <StyledInputGroupFilter
                        formName='filtersForm.image_validations.mistake_set_by_user'
                        singleChoice={true}
                        onChange={() => this.props.setIsDirty(true)}
                        transString={'filter_mistake_set_by_user'}
                        iconType={'margin-radix'}
                        showClear={filtersForm.image_validations.mistake_set_by_user}
                        items={[
                            { value: '0', label: trans('status_NOT_OK') },
                            { value: '1', label: trans('status_OK') },
                        ]}
                        onClear={() => {
                            this.props.updateInputValue('filtersForm', 'image_validations.mistake_set_by_user', null)
                            this.props.setIsDirty(true)
                        }}
                    />
                </GridCell>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        availableOptions: state.availableOptions,
        filtersForm: selectFormValues(state,'filtersForm'),
    }
}

export default connect(mapStateToProps, {
    updateInputValue,
})(ValidationsFilters)
